// @flow

import { action, autorun, computed, observable } from "mobx";

import Store from "app/stores/Store";
import Notification, {
    types as notificationTypes
} from "app/models/Notification";

const defaultNotificationTimeout = 4000;

class AppearanceStore extends Store {
    @observable scale: number = 1;
    @observable notifications: Notification[] = [];
    @observable theme: string;
    @observable hiddenThumbnails: boolean = false;
    @observable embed: boolean = false;
    @observable isMobileBrowser: boolean;

    constructor() {
        super();

        // This ensures execution of this.updateBodyClasses() after document.body is defined
        // and each time any of the relevant observables are changed
        window.addEventListener("load", () => {
            autorun(() => this.updateBodyClasses());
        });

        this.isMobileBrowser = /Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i
            .test(navigator.userAgent);
    }

    @action setTheme(theme: string) {
        const oldTheme = this.theme;
        this.theme = theme;

        if (["dark", "white"].indexOf(oldTheme) !== -1) {
            // $FlowFixMe
            document.body.className = document.body.className.replace(
                `Theme--${oldTheme}`,
                `Theme--${this.theme}`
            );
        }
    }

    @action hideThumbnails(hide: any) {
        this.hiddenThumbnails = !!hide;
    }

    @action setHiddenThumbnails(hide: boolean) {
        this.hiddenThumbnails = hide;
    }

    @action setEmbed(embed: boolean) {
        this.embed = embed;
    }

    updateBodyClasses() {
        if(!document.body) {
            return;
        }

        window.setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
    }

    @action.bound updateScale(scale: number): void {
        this.scale = scale;
    }

    @action.bound notify(type: string, message: string, timeout?: number) {
        const notification = new Notification();
        notification.type = type;
        notification.message = message;

        this.notifications.push(notification);

        setTimeout(
            () => this.removeNotification(notification),
            timeout || defaultNotificationTimeout
        );
    }

    @action.bound removeNotification(notification: Notification) {
        const index = this.notifications.indexOf(notification);
        if (index === -1) return;

        this.notifications.splice(index, 1);
    }

    @action.bound notifySuccess(message: string, timeout?: number): void {
        this.notify(notificationTypes.SUCCESS, message, timeout);
    }

    @action.bound notifyWarning(message: string, timeout?: number): void {
        this.notify(notificationTypes.WARNING, message, timeout);
    }

    @action.bound notifyError(message: string, timeout?: number): void {
        this.notify(notificationTypes.ERROR, message, timeout);
    }

    @computed get isMobile(): boolean {
        return this.embed || this.scale === -1;
    }

    @computed get timelineContentLength(): number {
        return this.isMobile ? 200 : 500;
    }
}

export default new AppearanceStore();



// WEBPACK FOOTER //
// ./src/app/stores/AppearanceStore.js